import { render, staticRenderFns } from "./IconAssingTask.vue?vue&type=template&id=29edf0b3"
import script from "./IconAssingTask.vue?vue&type=script&lang=js"
export * from "./IconAssingTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports